import React from 'react';
import { Tab } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import LogsTable from '../../components/LogsTable';
import ContextLogsTable from '../../components/ContextLogsTable';
import { isRoot } from '../../helpers';
import { StudioHero, StudioPage } from '../../components/StudioPage';
import './Logs.css';

/**
 * 日志管理页面容器
 * 包含普通日志和上下文日志两个标签页
 * 修改时间：2026-06-12
 */
const Log = () => {
  const { t } = useTranslation();

  const panes = [
    {
      menuItem: t('log.title'),
      render: () => (
        <Tab.Pane attached={false}>
          <LogsTable />
        </Tab.Pane>
      ),
    },
  ];

  if (isRoot()) {
    panes.push({
      menuItem: t('log.studio.context_tab'),
      render: () => (
        <Tab.Pane attached={false}>
          <ContextLogsTable />
        </Tab.Pane>
      ),
    });
  }

  return (
    <StudioPage className='studio-logs-page'>
      <StudioHero
        icon='file alternate outline'
        kicker='AI STUDIO / OBSERVABILITY'
        title={t('log.title')}
        description={t('log.studio.subtitle')}
        className='studio-logs-hero'
      >
        <div className='studio-logs-hero__signal' aria-label={t('log.studio.live')}>
          <span className='studio-logs-hero__signal-dot' />
          <span>{t('log.studio.live')}</span>
        </div>
      </StudioHero>
      <section className='studio-logs-shell'>
        <Tab
          className='studio-tabs studio-logs-tabs'
          menu={{ secondary: true, pointing: true }}
          panes={panes}
        />
      </section>
    </StudioPage>
  );
};

export default Log;
